

module.exports = __webpack_require__.stylable.create(
    "OfferingInfo207476195",
    {"classes":{"root":"OfferingInfo207476195__root","verticalLayout":"OfferingInfo207476195__verticalLayout","horizontalLayout":"OfferingInfo207476195__horizontalLayout","column":"OfferingInfo207476195__column","OfferingName":"","OfferingCTA":"","textButtonWrapper":"OfferingMoreInfoLabel1926614395__textButtonWrapper","OfferingTagLine":"","divider":"OfferingInfo207476195__divider","buttonWrapper":"OfferingCTA777952320__buttonWrapper","srOnly":"OfferingInfo207476195__srOnly"},"vars":{},"stVars":{"MobileMinHeight":"26px"},"keyframes":{}},
    "",
    16,
    "OfferingInfo207476195",
    null
);
